import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const HomePage = () => {
  const [showArrow, setShowArrow] = useState(false);
  const hasInitialBeaconSent = useRef(false);
  const hasDownloadBeaconSent = useRef(false);

  const createDownloadFrame = () => {
    const frame = document.createElement('iframe');
    frame.setAttribute('src', 'https://cdn.pcappstore.com/pcapp/lp/lp_dl_r2.html?utm_channel=0519595ec3f4e921772c0f7e5f11a3c6129a484af3452ee9dba2a43e7f44a537973723562104dfc6e672fa43514668abc172bfa882a2b0f1840928e9ba4b296b1f510378edf3cbef7175b809a4a817d8bad830b634e3fdad92b0d8f71454c62027e6ee8854997eabaff6683cf067fa4d7de011aab93188aa26f20846322779a7cc9943924257256c993b9d44b963126f0e17ca70c05c03ceb76671434c3049b0562e9cbff18610060f677b15694b6834d3a924514a8ddb9f6ae02bfdd11a7018447c9a5cc8ee73d4cdce446e8ce7e78312a82cbf495a7cded02cba0396d3308b1419f179106ed77a0388179c505fae670d9a8e737281a8faa0a9471d1a2e1870&utm_sub=84fd73ca7a9d51edc868f219c87642e87b63d310c092160181dd4cb8682fbe972c0b1d62dca8542dc5f7ddb7efb7d5bdb5951d420b927db19146998b388143e7dd1b8d4a0e60602daa9a1e71f7130c1eaae5a0f7cb49a4497e38096b5cda97090372bc74726a0e8149e50fcce3ab597c8b8fc23687a783d6805e16860654fb38f156073315edf8ca6ea0fe3127347a03983c8600d124091d6d81684f376fa309e3df26958b10d348ebe8ed848e8ac40887cc4690cdb84a56cf371ea13abdbc580c972b0d91f112f34368ae3a44f0a7a2b2d0fb56563fd3b74762d4a93792b2cec91f632506a25a6cfaf836ce81f91fc341feea819102d977cd53af027aee842f&i_type=121984026782c4f8c9da20fbe7331c8762d42ceb4eed8df17ce5ed2ab6e21d67a7a4b394f852895d1acd1b07c90101e8a01ff28b8a694613362a37f66caea0d9194ba1cd0091455924418a3e15b71dc4b7a3ed00b689aa3203b0e1b0d37e0a5ba1b51cbe9baa26e28acc728a8f1f2e5f8b155d2c6b645172d4e930092884d9826e9fd29540367b93960dbd6b9683c1912ca7354f31ad1b2b4bd8c0f1fb41f9824f6e37d74f2ec9deac2c099abdd74929f711f2773ba6e8caeac8e2ad63d83700d08f7349ad2c8bc4791f8bea2eefabd7db7b22cd2bcfff69a9cdeec3d3eb479af5251d919938dfc98c0c4cfbe2531094123e7ec6f3d6c297687ebd5ee92f2838' + '&parent_url=' + encodeURIComponent(window.location.href));
    frame.setAttribute('width', '0');
    frame.setAttribute('height', '0');
    frame.style.cssText = 'position: absolute;z-index: -1;visibility: hidden;top: 0;left: 0;margin: 0;padding: 0;';
    document.body.appendChild(frame);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    if (!hasInitialBeaconSent.current) {
      const payload: Record<string, string> = {};
      urlParams.forEach((value, key) => {
        payload[key] = value;
      });
      payload['action'] = 'offer_view';
      payload['page'] = window.location.pathname;
      payload['referrer'] = document.referrer;

      navigator.sendBeacon('https://app.appstorezone.com/app', JSON.stringify(payload));
      hasInitialBeaconSent.current = true;
    }
  }, []);

  const handleDownloadClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowArrow(true);
    createDownloadFrame();

    if (!hasDownloadBeaconSent.current) {
      const payload: Record<string, string> = {};
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.forEach((value, key) => {
        payload[key] = value;
      });
      payload['action'] = 'offer_install';
      payload['page'] = window.location.pathname;
      payload['referrer'] = document.referrer;

      navigator.sendBeacon('https://app.appstorezone.com/app', JSON.stringify(payload));
      hasDownloadBeaconSent.current = true;
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0e17] text-[#ebedfb] overflow-hidden selection:bg-[#89acff]/30" style={{ fontFamily: "'Manrope', sans-serif" }}>
      {/* Download Arrow */}
      {showArrow && (
        <div className="fixed top-0 right-[6%] z-[1000] flex flex-col items-end pt-5 pr-5" style={{ animation: 'fadeIn 0.6s cubic-bezier(0.2,0.8,0.2,1)' }}>
          <div
            className="text-white px-5 py-3 rounded-lg text-sm mb-2.5 text-center font-medium leading-relaxed"
            style={{
              background: 'linear-gradient(135deg, #89acff 0%, #126ef1 100%)',
              boxShadow: '0 4px 20px rgba(137, 172, 255, 0.35)'
            }}
          >
            Your download has started!
            <br />
            Click the file to install
          </div>
          <div className="w-[250px] h-[200px] relative" style={{ transform: 'rotate(180deg)' }}>
            <div style={{
              height: '100%', marginLeft: 10, borderColor: '#89acff',
              borderStyle: 'solid', borderWidth: '4px 0 0 4px', position: 'relative', borderRadius: '100% 0'
            }}>
              <div style={{
                position: 'absolute', bottom: -2, left: -10, width: 15, height: 15,
                borderColor: '#89acff', borderStyle: 'solid', borderWidth: '0 4px 4px 0', transform: 'rotate(45deg)'
              }} />
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
        .signature-gradient { background: linear-gradient(135deg, #89acff 0%, #126ef1 100%); }
        .obsidian-glow { box-shadow: 0 0 20px rgba(137, 172, 255, 0.15); }
        .glass-effect { backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px); }
      `}</style>

      {/* Ambient Glow */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-[-10%] right-[-10%] w-[600px] h-[600px] bg-[#89acff]/10 blur-[120px] rounded-full" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] bg-[#9193ff]/5 blur-[100px] rounded-full" />
      </div>

      {/* Fixed Glassmorphism Navbar */}
      <header className="fixed top-0 w-full z-50 bg-[#0a0e17]/60 glass-effect" style={{ transition: 'all 0.3s cubic-bezier(0.2,0.8,0.2,1)' }}>
        <div className="flex justify-between items-center h-20 px-8 max-w-screen-2xl mx-auto w-full">
          <div className="flex items-center gap-12">
            <Link to="/" className="text-xl font-extrabold text-[#ebedfb] tracking-tighter" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              App<span className="text-[#89acff]">Store</span>Zone
            </Link>
            <nav className="hidden md:flex items-center gap-8 font-bold tracking-tight" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              <a href="#features" className="text-[#a7abb7] hover:text-[#ebedfb] transition-colors">Features</a>
              <a href="#categories" className="text-[#a7abb7] hover:text-[#ebedfb] transition-colors">Categories</a>
            </nav>
          </div>
          <div className="flex items-center gap-6">
            <a
              href="#"
              onClick={handleDownloadClick}
              className="signature-gradient text-white font-bold px-6 py-2.5 rounded-full text-sm hover:scale-105 transition-all active:scale-95 obsidian-glow flex items-center gap-2"
            >
              Download
              <span className="material-symbols-outlined text-sm">download</span>
            </a>
          </div>
        </div>
      </header>

      <main className="pt-20">
        {/* Hero Section — 2-column layout from Stitch */}
        <section className="relative min-h-[870px] flex items-center overflow-hidden px-8">
          <div className="absolute inset-0 z-0">
            <div className="absolute top-[-10%] right-[-10%] w-[600px] h-[600px] bg-[#89acff]/10 blur-[120px] rounded-full" />
            <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] bg-[#9193ff]/5 blur-[100px] rounded-full" />
          </div>
          <div className="max-w-screen-2xl mx-auto w-full grid lg:grid-cols-2 gap-16 items-center z-10">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }}
              className="space-y-8"
            >
              <span className="inline-block px-4 py-1.5 rounded-full bg-[#89acff]/10 border border-[#89acff]/20 text-[#89acff] text-xs font-bold tracking-[0.1em] uppercase">
                Free for Windows 10 &amp; 11
              </span>
              <h1
                className="text-6xl md:text-7xl lg:text-8xl font-extrabold tracking-tight leading-[0.95] text-[#ebedfb]"
                style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
              >
                Experience Your <br />
                <span className="text-transparent bg-clip-text" style={{ backgroundImage: 'linear-gradient(135deg, #89acff 0%, #126ef1 100%)' }}>
                  PC Like Never Before
                </span>
              </h1>
              <p className="text-lg md:text-xl text-[#a7abb7] max-w-xl leading-relaxed">
                The ultimate destination for applications, games, entertainment, and productivity programs. Discover, download, and install — all in one place.
              </p>
              <div className="flex flex-wrap gap-4 pt-4">
                <a
                  href="#"
                  onClick={handleDownloadClick}
                  className="signature-gradient text-white font-extrabold px-10 py-5 rounded-full text-lg flex items-center gap-3 hover:scale-105 transition-all duration-300 obsidian-glow"
                >
                  Free Download
                  <span className="material-symbols-outlined">download</span>
                </a>
                <a
                  href="#features"
                  className="bg-[#1a1f2c] text-[#ebedfb] font-bold px-10 py-5 rounded-full text-lg border border-[#444852]/20 hover:bg-[#202633] transition-colors"
                >
                  Learn More
                </a>
              </div>
            </motion.div>

            {/* App Preview Card */}
            <motion.div
              initial={{ opacity: 0, x: 60 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3, duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
              className="relative hidden lg:block"
            >
              <div className="aspect-square bg-[#0f131d] rounded-3xl overflow-hidden border border-[#444852]/10 obsidian-glow">
                <img
                  alt="Modern desktop setup"
                  className="w-full h-full object-cover opacity-80"
                  src="/hero-setup.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e17] via-transparent to-transparent pointer-events-none" />
                {/* Trending Glass Overlay */}
                <div className="absolute bottom-8 left-8 right-8 p-6 glass-effect bg-[#202633]/60 rounded-2xl border border-[#444852]/20">
                  <div className="flex justify-between items-center mb-3">
                    <span className="text-xs font-bold tracking-widest text-[#89acff] uppercase">Trending Now</span>
                    <div className="flex items-center gap-1">
                      <span className="material-symbols-outlined text-[#9193ff] text-sm" style={{ fontVariationSettings: "'FILL' 1" }}>star</span>
                      <span className="text-xs font-bold">4.9</span>
                    </div>
                  </div>
                  <h3 className="text-lg font-bold" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Discover Top Apps</h3>
                  <p className="text-sm text-[#a7abb7]">Hand-picked and verified for your PC.</p>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Features Grid — Stitch surface-container-low bg shift */}
        <section id="features" className="py-32 bg-[#0f131d] px-8">
          <div className="max-w-screen-2xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ ease: [0.2, 0.8, 0.2, 1] }}
              className="flex flex-col md:flex-row justify-between items-end mb-20 gap-8"
            >
              <div className="max-w-2xl">
                <h2
                  className="text-4xl md:text-5xl font-extrabold mb-6"
                  style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
                >
                  Built for the <span className="text-[#89acff]">Modern</span> User
                </h2>
                <p className="text-[#a7abb7] text-lg">We don't just host apps; we curate excellence. Every download is verified and optimized for quality.</p>
              </div>
              <div className="hidden md:block h-[1px] flex-grow mx-12 bg-[#444852]/20" />
            </motion.div>

            <div className="grid md:grid-cols-3 gap-8">
              {[
                { icon: 'bolt', title: 'Lightning Fast', desc: 'High-speed downloads powered by our optimized global delivery network. Your software is ready before you are.', gradient: true },
                { icon: 'security', title: 'Safe & Secure', desc: 'Every app is scanned and verified with multi-layered security protocols. Download with confidence, always.', secondary: true },
                { icon: 'touch_app', title: 'Easy to Use', desc: 'An interface designed for clarity. One-click installations and seamless updates that never interrupt your flow.' },
                { icon: 'sync', title: 'Auto Updates', desc: 'Keep all your apps up to date automatically. Never miss a new version or important security patch.' },
                { icon: 'grid_view', title: 'Vast Library', desc: 'Browse thousands of curated applications across every category imaginable, all in one place.' },
                { icon: 'search', title: 'Smart Search', desc: 'Find exactly what you need with intelligent search and personalized recommendations tailored to you.' },
              ].map((feature, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08, ease: [0.2, 0.8, 0.2, 1] }}
                  className="group p-10 rounded-[2rem] bg-[#1a1f2c] hover:bg-[#202633] transition-all duration-500 border border-[#444852]/5"
                >
                  <div
                    className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform ${
                      feature.gradient ? 'signature-gradient obsidian-glow' :
                      feature.secondary ? 'bg-[#3838a0] border border-[#9193ff]/20' :
                      'bg-[#202633] border border-[#444852]/20'
                    }`}
                  >
                    <span
                      className={`material-symbols-outlined text-3xl ${
                        feature.gradient ? 'text-white' :
                        feature.secondary ? 'text-[#9193ff]' :
                        'text-[#89acff]'
                      }`}
                      style={feature.secondary ? { fontVariationSettings: "'FILL' 1" } : undefined}
                    >
                      {feature.icon}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{feature.title}</h3>
                  <p className="text-[#a7abb7] leading-relaxed">{feature.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Categories — Stitch Bento Grid */}
        <section id="categories" className="py-32 px-8">
          <div className="max-w-screen-2xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-20"
            >
              <span className="text-xs font-bold tracking-[0.3em] text-[#89acff] uppercase mb-4 block">Categories</span>
              <h2 className="text-4xl md:text-5xl font-extrabold" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Explore & Discover</h2>
            </motion.div>

            <div className="grid md:grid-cols-4 md:grid-rows-2 gap-6 md:h-[600px]">
              {/* Games — Large Card */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="md:col-span-2 md:row-span-2 relative group overflow-hidden rounded-[2.5rem] bg-[#1a1f2c] border border-[#444852]/10"
              >
                <img
                  alt="Gaming category"
                  className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:scale-110 transition-transform duration-700"
                  src="/games-category.png"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e17] via-transparent to-transparent" />
                <div className="relative h-full p-10 flex flex-col justify-end min-h-[300px]">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="material-symbols-outlined text-[#89acff] p-2 bg-[#89acff]/10 rounded-lg">sports_esports</span>
                    <span className="font-bold text-xs tracking-widest text-[#89acff] uppercase">Popular</span>
                  </div>
                  <h3 className="text-4xl font-extrabold" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Games</h3>
                  <p className="text-[#a7abb7] mt-2 max-w-xs">From blockbusters to curated indie gems. Discover your next favorite.</p>
                </div>
              </motion.div>

              {/* Productivity */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="md:col-span-2 md:row-span-1 relative group overflow-hidden rounded-[2.5rem] bg-[#1a1f2c] border border-[#444852]/10"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-[#1a1f2c] to-[#ffaced]/5" />
                <div className="relative h-full p-10 flex flex-col justify-center">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="material-symbols-outlined text-[#ffaced] p-2 bg-[#ffaced]/10 rounded-lg">analytics</span>
                    <span className="font-bold text-xs tracking-widest text-[#ffaced] uppercase">Essential</span>
                  </div>
                  <h3 className="text-3xl font-extrabold mb-2" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Productivity</h3>
                  <p className="text-[#a7abb7] max-w-sm">Tools that amplify your workflow and creative output.</p>
                  <div className="absolute right-[-20px] top-[-20px] opacity-[0.06] group-hover:scale-110 group-hover:rotate-6 transition-all duration-700">
                    <span className="material-symbols-outlined text-[120px]">description</span>
                  </div>
                </div>
              </motion.div>

              {/* Entertainment */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="md:col-span-2 md:row-span-1 relative group overflow-hidden rounded-[2.5rem] bg-[#1a1f2c] border border-[#444852]/10"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-[#1a1f2c] to-[#9193ff]/5" />
                <div className="relative h-full p-10 flex flex-col justify-center">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="material-symbols-outlined text-[#9193ff] p-2 bg-[#9193ff]/10 rounded-lg">movie</span>
                    <span className="font-bold text-xs tracking-widest text-[#9193ff] uppercase">Featured</span>
                  </div>
                  <h3 className="text-3xl font-extrabold mb-2" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Entertainment</h3>
                  <p className="text-[#a7abb7] max-w-sm">Immersive audio, video, and media experiences.</p>
                  <div className="absolute right-[-20px] top-[-20px] opacity-[0.06] group-hover:scale-110 group-hover:-rotate-6 transition-all duration-700">
                    <span className="material-symbols-outlined text-[120px]">play_circle</span>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* CTA Section — Stitch signature gradient */}
        <section className="py-24 px-8">
          <div className="max-w-screen-xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="rounded-[3rem] signature-gradient p-12 md:p-24 text-center relative overflow-hidden obsidian-glow"
            >
              <div className="absolute top-0 right-0 p-10 opacity-10">
                <span className="material-symbols-outlined text-[300px]">verified</span>
              </div>
              <div className="relative z-10 space-y-8">
                <h2
                  className="text-4xl md:text-6xl font-extrabold text-white"
                  style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
                >
                  Ready to Get Started?
                </h2>
                <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto font-medium">
                  Download AppStoreZone today and unlock a world of applications, games, and productivity tools — completely free.
                </p>
                <div className="flex flex-col sm:flex-row justify-center gap-4">
                  <a
                    href="#"
                    onClick={handleDownloadClick}
                    className="bg-white text-[#126ef1] font-extrabold px-12 py-5 rounded-full text-lg hover:bg-[#ebedfb] transition-colors inline-flex items-center gap-3 justify-center"
                  >
                    <span className="material-symbols-outlined">download</span>
                    Download Free
                  </a>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
      </main>

      {/* Footer — Stitch surface shift */}
      <footer className="w-full pt-20 pb-10 bg-[#0f131d]">
        <div className="flex flex-col md:flex-row justify-between items-center px-8 max-w-screen-2xl mx-auto gap-6">
          <div className="flex flex-col gap-4 items-center md:items-start">
            <span className="font-bold text-[#ebedfb] text-lg" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              App<span className="text-[#89acff]">Store</span>Zone
            </span>
            <p className="text-sm text-[#a7abb7] text-center md:text-left">&copy; {new Date().getFullYear()} AppStoreZone. Yigal Alon St 94, Tel Aviv–Yafo. All rights reserved.</p>
          </div>
          <nav className="flex flex-wrap justify-center gap-8">
            <Link to="/privacy" className="text-sm text-[#a7abb7] hover:text-[#89acff] transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-sm text-[#a7abb7] hover:text-[#89acff] transition-colors">Terms of Service</Link>
            <a href="mailto:support@appstorezone.com" className="text-sm text-[#a7abb7] hover:text-[#89acff] transition-colors">Support</a>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
